import { supabase } from "@/integrations/supabase/client";

/**
 * Muda a data de uma diária e leva o hold do plano junto, para que a cota da
 * semana continue contando o dia certo.
 */
export async function moveStayDay({
  dayId,
  toDate,
  contractId,
}: {
  dayId: string;
  toDate: string;
  contractId: string | null;
}): Promise<void> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const client = supabase as any;

  const { data: day, error: readError } = await client
    .from("stay_reservation_days")
    .select("stay_date")
    .eq("id", dayId)
    .single();
  if (readError) throw readError;

  const { error: moveError } = await client
    .from("stay_reservation_days")
    .update({ stay_date: toDate })
    .eq("id", dayId);
  if (moveError) throw moveError;

  if (!contractId) return;

  const { error: holdError } = await client
    .from("stay_reservation_daycare_plan_usages")
    .update({ used_on: toDate })
    .eq("contract_id", contractId)
    .eq("source", "hold")
    .eq("used_on", day.stay_date);
  if (holdError) throw holdError;
}
